import React, { Component } from 'react';
import './CreateDrugOrderFormPopup.css';
import moment from 'moment';

import cloneDeep from 'lodash.clonedeep';
import toasts from "../../utils/toasts";
import utils from "../../utils/utils";
import mainAPI from "../../api/MainAPI";
import Popup from "../../components/popup/Popup";
import Label from "../../components/label/Label";
import Input from "../../inputs/input/Input";
import UniversalDropDown from "../../components/universalDropDown/UniversalDropDown";
import Button from "../../components/button/Button";


class CreateDrugOrderFormPopup extends Component {
	constructor() {
		super();
		this.state = {
			form: {
				form_number: '',
				supplier_dea_number: '',
				type: '',
				ordered_on: '',
				received_on: ''
			}
		};
		this.inputRefs = {};
	}


	_onHandleChange = (field, value) => {
		const { form } = this.state;
		if ((field === 'ordered_on' || field === 'received_on') && value) {
			const dateStr = value;
			const [year, month, day] = dateStr.split('-').map(Number);
			const date = new Date(year, month - 1, day, 12, 0, 0, 0);
			value = date.toISOString();
		}
		this.setState({
			form: { ...form, [field]: value }
		});
	};

	_createNewForm = async () => {
		const { form } = cloneDeep(this.state);
		const { onClose } = this.props;
		const {valid, required} = this._checkAllFields();
		if (required.length === 1) {
			return toasts.show(`${required[0]} is required.`);
		}
		if (required.length > 1) {
			return toasts.show(`${required.join(', ')} fields are required.`);
		}
		
		if (form.ordered_on && form.received_on) {
			const orderedDate = new Date(form.ordered_on);
			const receivedDate = new Date(form.received_on);
			if (receivedDate < orderedDate) {
				return toasts.show('Received date cannot be before ordered date');
			}
		}

		if (valid) {
			const formToSubmit = { ...form };
			if (formToSubmit.ordered_on) {
				formToSubmit.ordered_on = utils.client_to_server_datetime(new Date(formToSubmit.ordered_on));
			}
			if (formToSubmit.received_on) {
				formToSubmit.received_on = utils.client_to_server_datetime(new Date(formToSubmit.received_on));
			}
			let res = await mainAPI.drug_order_form.create(formToSubmit);
			if (!res) return toasts.show('Drug Order Form was not created');
			onClose();
		}
	};

	_checkAllFields = () => {
		const failed = [];
		const fieldLabels = {
			form_number: 'Form Number'
		};

		Object.keys(this.inputRefs).forEach((fieldName) => {
			const input = this.inputRefs[fieldName];
			if (input && input.isValid && !input.isValid()) {
				failed.push(fieldLabels[fieldName] || fieldName);
			}
		});

		return {valid: failed.length < 1, required: failed}
	};

	render() {
		const {
			form: { form_number, supplier_dea_number, type, ordered_on, received_on } = {}
		} = this.state;
		const { onClose, show } = this.props;
		let showProp = show;
		if (!this.props.hasOwnProperty('show')) {
			showProp = true;
		}
		return (
			<Popup {...this.props} show={showProp} className="create-drug-order-form-popup">
				<div className="modal">
					<div className="card card-create">
						<Label black large className="card-create-label">
							Add Drug Order Form
						</Label>
						<div className="create">
							<div>
								<div className="create-field">
									<Label className="create-field-label" gray-medium>
										Form Number
									</Label>
									<Input
										ref={(ref) => this.inputRefs.form_number = ref}
										className="create-field-input-field"
										required
										onChange={(e) => {
											this._onHandleChange('form_number', e);
										}}
										value={form_number}
									/>
								</div>
								<div className="create-field">
									<Label className="create-field-label" gray-medium>
										Supplier DEA Number
									</Label>
									<Input
										className="create-field-input-field"
										onChange={(e) => {
											this._onHandleChange('supplier_dea_number', e);
										}}
										value={supplier_dea_number}
									/>
								</div>
								<div className="create-field">
									<Label className="create-field-label" gray-medium>
										Type
									</Label>
									<UniversalDropDown
										className="create-field-input-field"
										placeholder="Type"
										options={{'DEA 222': {id: 'DEA 222', name: 'DEA 222'}, 'Schedule 3': {id: 'Schedule 3', name: 'Schedule 3'}}}
										onChange={(e) => {
											this._onHandleChange('type', e);
										}}
										value={type}
									/>
								</div>
							</div>
							<div>
								<div className="create-field">
									<Label className="create-field-label" gray-medium>
										Ordered On
									</Label>
									<Input
										className="create-field-input-field"
										type="date"
										onChange={(value) => {
											this._onHandleChange('ordered_on', value);
										}}
										value={ordered_on ? moment(ordered_on).format('YYYY-MM-DD') : ''}
									/>
								</div>
								<div className="create-field">
									<Label className="create-field-label" gray-medium>
										Received On
									</Label>
									<Input
										className="create-field-input-field"
										type="date"
										onChange={(value) => {
											this._onHandleChange('received_on', value);
										}}
										value={received_on ? moment(received_on).format('YYYY-MM-DD') : ''}
									/>
								</div>
							</div>
						</div>
						<div className="card-actions">
							<Button className="card-actions-button" color="white" bg="red" onClick={onClose}>
								Cancel
							</Button>
							<Button
								className="card-actions-button"
								color="white"
								bg="blue"
								onClick={this._createNewForm}
							>
								Add Form
							</Button>
						</div>
					</div>
				</div>
			</Popup>
		);
	}
}

export default CreateDrugOrderFormPopup;




// WEBPACK FOOTER //
// ./src/popups/createDrugOrderFormPopup/CreateDrugOrderFormPopup.jsx